<template>
    <div class="tab-cover-wrap ">
        <h1 class="text-[16px] font-bold text-[#14171F]">Provide a means of identification for (beneficial owner’s name)
        </h1>
        <p class="text-[16px] font-normal text-[#14171F] mt-4">As a regulated service industry, we would need to verify
            your identity.</p>


        <form @submit.prevent="verifyDoc">
            <div class="mt-4 p-[20px]">
                <div class="flex justify-between items-center mb-4">
                    <h5 class="text-[#321C3B] text-[600]">{{this.ownerData.fullName}}</h5>
                    <button @click.prevent="showInfo" class="pt-2">
                        <span v-if="isExpanded" >&#710;</span>
                        <span v-else >&#711; </span>
                    </button>
                </div>
                <div v-if="isExpanded" class="flex flex-wrap gap-6 w-full ">
                    <div class="flex-1 ">
                        <label for="doc" class="label">Identity Document Number</label>
                        <div class="doc-cover flex px-2 ">
                            <div class="flex-1 ">
                                <select v-model="kyc.selectedDoc" @change="selectDocOption">
                                    <option disabled value="">-- Select document --</option>
                                    <option  v-for="(item, index) in document"
                                        :key="index" :value="item">{{ item || '' }}</option>
                                </select>
                            </div>
                            <div class="flex-1">
                                <input type="text" v-model="kyc.identity" placeholder="-- Enter Identity Number --" />
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 upload-wrap ">
                        <label for="" class="text-[16px] font-normal text-[#14171F]">Document Upload</label>
                        <input ref="fileInput" type="file" style="display: none;" accept="image/*"
                            @change="onFileSelected">
                        <button v-if="!imageUrl.document" @click.prevent="selectImage('document')"
                            class="flex justify-between items-center px-4 py-2 w-[220px]">
                            <p class="text-[14px] font-normal text-[#7A90A7]">Upload File </p>
                            <img src="@/assets/images/ondemand/upload-icon-claim.svg" alt="" srcset="">
                        </button>
                        <button v-if="imageUrl.document" class=" flex justify-between items-center px-2 py-2 w-[250px]">
                            <img width=""
                                src="@/assets/images/ondemand/uploaded-file-icon.svg" alt="Selected Image" />
                            <p class="text-[14px] font-normal text-[#383F51]">{{ kyc.document }}</p>
                            <img @click.prevent="removeImage(imageUrl.document, 'document')"
                                src="@/assets/images/ondemand/claim-icon-close.svg" alt="" srcset="">
                        </button>
                        
                    </div>
                </div>
            </div>
            <hr>
            <div class="next-submit flex justify-end mt-4">
                <button  @click="goToAddress"
                    :class="['py-2 px-4 text-[16px] font-semibold text-[#10233E] transition-all duration-300', buttonClass]">
                    next
                </button>
            </div>
        </form>

    </div>
</template>

<script>


export default {

    data() {
        return {
            
            isExpanded: true,
            selected: null,
            document: [
                'Nigerian Bank Identification Number (BVN)',
                'International Passport',
                'National Identitiy Number (NIN)',
                "Driver's License",
                "Voter's Card"
            ],
            kyc: {
                identity: '',
                document: '',
                selectedDoc: "",
            },
             imageUrl: {
                document: '',
            },
        };
    },

      props: [ 'ownerData'],

    computed: {
        buttonClass() {
            return this.isFormValid
                ? 'opacity-100 cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed';
        },
        isFormValid() {
            return (
                this.imageUrl.document && 
                this.kyc.identity 
            );
        }
    },

    methods: {
          selectDocOption() {
    console.log("Selected item:", this.kyc.selectedDoc);
  },
        showInfo() {
            this.isExpanded = !this.isExpanded
        },
         goToAddress(e) {
            e.preventDefault();
            if (this.isFormValid) {
                this.$emit('openAddress', {
                    ...this.kyc,
                    ...this.imageUrl,
                });
            } else {
                this.generateToast("Form is invalid, cannot proceed.", "error");
                return;
            }
            this.kyc = {
                identity: '',
                document: '',
            }
        },
     

        selectImage(fileType) {
            this.$refs.fileInput.click();
            this.fileType = fileType
        },
        onFileSelected(event) {
            const file = event.target.files[0];
            if (file.size > 1048576) {
                this.generateToast("Selected image size is too large. Please upload an image smaller than 1MB!", "error");
                return;
            }

            if (this.fileType === 'document' && file && file.type.startsWith('image/')) {
                this.kyc.document = file.name;
                this.uploadImage(file, 'document');
                this.$forceUpdate();
            } else {
                this.generateToast("Please select a valid image file!", "error");
                this.imageUrl = null;
            }

        },
        async uploadImage(image, type) {
            this.isUploadingImage = true;

            const formData = new FormData();
            formData.append("file", image);
            formData.append("upload_preset", "zunt8yrw");

            try {
                const response = await this.$_uploadImage(formData);
                const imageUrl = response?.data?.fileUrl;

                if (!imageUrl) throw new Error("Upload failed: no URL returned");
                if (type === 'document' && imageUrl) {
                    this.imageUrl.document = imageUrl;
                    this.generateToast("Image uploaded", "success");
                }
            } catch (error) {
                this.handleError(error);
            } finally {
                this.isUploadingImage = false;
            }
        },
        removeImage(file, fileType) {
            this.fileType = fileType
            if (file === this.imageUrl.document && this.fileType === 'document') {
                this.imageUrl.document = null
                this.$refs.fileInput.value = '';
                this.$forceUpdate();
            }
        },
    },

};
</script>

<style scoped>
input,
select {
    outline: none;
    background-color: transparent;
    padding: 2% 0 2% 2%;
    width: 100%;
}

.doc-cover {
    border: 1px solid #C2C7D6;
    width: 100%;
    border-radius: 8px;
   
}
.doc-cover>:nth-child(2) {
     padding-top: 1%;
    padding-bottom: 1%;
}

.doc-cover>:nth-child(1) {
    border-right: 1px solid #C2C7D6;
     padding-top: 1%;
    padding-bottom: 1%;
}
.upload-wrap {
    /* border: 1px solid red; */
}
span {
    font-size: 35px;
}
.upload-wrap>button {
  border: 1px solid #C2C7D6;
  border-radius: 124px;
  background-color: transparent;
  cursor: pointer;
}
.next-submit>button {
    background-color: #FCC210;
    border-radius: 2px;
}
hr{
    border: 1px solid #C2C7D6;
    margin-top: 2%;
}
</style>
